import React, { Component } from "react";
import { HashRouter, Route } from "react-router-dom";
import axios from "axios";
import { connect } from "react-redux";
import { loadWidget } from "./redux/actions/widget";
import { base_url, query_string } from "./helper/common-vars";
import { loadWidgetData, getQueryString } from "./helper/common-methods";

import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./custom.js";

import View from "./components/View";
import "./App.css";
class App extends Component {
  componentDidMount = () => {
    let script_id = window.script_id;
    if (
      query_string &&
      query_string.script_id &&
      query_string.script_id != ""
    ) {
      script_id = query_string.script_id;
    }

    if (script_id !== "") {
      this.props.setQueryString({
        type: "Set_Script_id",
        script_id: script_id,
      });
      setTimeout(() => {
        let url =
          base_url +
          "/vr/api/visualizer/widgetV2/id/" +
          script_id +
          "/newUI2?common_ui=1&v=3.67307";
        loadWidgetData(url, () => {
          this.props.loadStateContainer(script_id);
        });
      }, 300);
    }
  };

  componentDidUpdate() {
    if (this.props.vtv_id != 0) {
      let num = parseInt(this.props.vtv_id);
      // this.props.GetTemplate(num.toString(36));
    }
  }

  render() {
    const { script_id } = this.props;
    if (script_id !== "") {
      return <View />;
    } else {
      return <></>;
    }
  }
}

const mapStateToProps = (state) => ({
  group_variables: state.widget_reducer.group_variables,
  app_loading: state.widget_reducer.app_loading,
  query_string: state.widget_reducer.query_string,
  script_id: state.widget_reducer.script_id,
  isPDFView: state.widget_reducer.isPDFView,
  extension_variables: state.widget_reducer.extension_variables,
  vtv_id: state.widget_reducer.vtv_id,
  isDownloading: state.widget_reducer.isDownloading,
  visualizer_input_output_values:
    state.widget_reducer.visualizer_input_output_values,
});

const mapDispatchToProps = (dispatch) => {
  return {
    loadStateContainer: (script_id) => dispatch(loadWidget(script_id)),
    setQueryString: (query_string_container) =>
      dispatch(query_string_container),
    updateQueryString: (query_string_container) =>
      dispatch(query_string_container),
  };
};

// export default App;
export default connect(mapStateToProps, mapDispatchToProps)(App);
